// extracted by mini-css-extract-plugin
module.exports = {"header":"_1B5rF","more":"D1Szw","items":"_2KdrQ","item":"_3Psie","date":"_1q_kN","title":"CIquG","content":"_1Vy6v"};